import { StyledLink } from "./styles";

export const ManagePaymentOptionsButton = () => (
  <StyledLink to="/account/manage-payment-methods">
    Manage payment options
  </StyledLink>
);
